import { Link } from "react-router-dom";
import { Home as HomeIcon } from "lucide-react";
import { useLanguage, pick } from "@/lib/i18n";
import { PATHS } from "@/lib/translations";

const COPY = {
    en: {
        title: "Lost in the jungle?",
        body: "We couldn’t find the page you were looking for. Let’s head back to base camp.",
        cta: "Back to home",
    },
    de: {
        title: "Im Dschungel verlaufen?",
        body: "Wir konnten die gesuchte Seite nicht finden. Zurück zum Basislager!",
        cta: "Zur Startseite",
    },
};

export default function NotFound() {
    const { lang } = useLanguage();
    const t = pick(COPY, lang);
    return (
        <section className="min-h-[60vh] flex items-center justify-center bg-leafy">
            <div className="max-w-xl mx-auto px-6 py-20 text-center">
                <p className="font-display text-7xl text-jungle-700 font-bold mb-2">404</p>
                <h1 className="font-display text-3xl sm:text-4xl text-jungle-900 font-bold">
                    {t.title}
                </h1>
                <p className="mt-3 text-ink-500">{t.body}</p>
                <Link
                    to={PATHS.home}
                    data-testid="notfound-home-btn"
                    className="inline-flex items-center gap-2 mt-6 px-6 py-3 rounded-full bg-jungle-700 text-cream-50 font-display font-semibold shadow-playful-sm hover:bg-jungle-900 transition-colors"
                >
                    <HomeIcon className="w-4 h-4" strokeWidth={2.5} />
                    {t.cta}
                </Link>
            </div>
        </section>
    );
}
